var _defs, _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBecksIconsCmsKidsPrimeMeals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#231f20;stroke-linecap:round;stroke-linejoin:round;stroke-width:4px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.99,94.94c5.74,4.9,13.93,6.11,20.28,3.76,3.1-1.15,5.98-2.92,8.82-4.54,3.12-1.77,6.18-3.64,9.16-5.62,5.88-3.9,11.49-8.2,16.79-12.87,5.96-5.25,11.5-10.98,16.63-17.09,4.68-5.72,6.1-14.91,2.34-22.32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M89.09,26.72c-4.16-1.55-8.54-1.71-12.52-.44-2.9,.92-5.47,2.59-7.49,4.79-2.81,3.07-5.46,6.26-8.41,9.18-5.93,5.87-12.41,11.14-19.36,15.74-3.54,2.34-7.2,4.51-10.98,6.48-2.82,1.47-5.36,3.03-7.37,5.57-3.1,3.93-4.39,9.17-3.62,14.53"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M94.59,24.64c-3.34,.13-5.26,2.32-7.23,4.79-2.6,3.25-5.3,6.41-8.12,9.48-11.18,12.21-24.06,22.92-38.07,31.74-3.49,2.2-7.06,4.28-10.7,6.23-1.71,.92-3.43,1.81-5.16,2.68-1.8,.9-3.72,1.65-5.46,2.67-5.14,3.03-5.03,10.93,.46,12.99,3.11,1.17,5.97-.35,8.84-1.73,3.66-1.77,7.26-3.66,10.81-5.65,7.17-4.03,14.11-8.5,20.74-13.38,14.8-10.89,28.07-23.83,39.38-38.26,.02-.03,.05-.06,.07-.09,.03-.04,.05-.07,.08-.11,1.67-2.34,2.16-5.35,.8-7.81-1.23-2.22-3.85-3.65-6.45-3.55Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M88.99,37.2c.06,1.17,.3,2.1-.24,3.21-1.52,3.11-5.08,3.02-7.79,4.59-3.21,1.86-3.37,4.97-4.63,8.12-1.42,3.53-5.28,2.85-8.27,4.19-3.13,1.4-3.78,4.38-5.07,7.26-.73,1.62-1.61,2.54-3.38,2.86-1.67,.31-3.38,.25-5.01,.76-3.21,1.02-3.93,4.22-5.33,6.88-1.65,3.13-5.68,1.53-8.51,2.32-1.73,.48-3.01,1.83-3.97,3.29-.79,1.2-1.39,2.97-2.54,3.87-1.35,1.04-2.8,.97-4.23,.37"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBecksIconsCmsKidsPrimeMeals);
export default __webpack_public_path__ + "static/media/BecksIcons_CMS_KidsPrimeMeals.62c7069cdf38189057a660d3a3b59fb0.svg";
export { ForwardRef as ReactComponent };